import { render, staticRenderFns } from "./choice-empty.vue?vue&type=template&id=255c4630"
import script from "./choice-empty.vue?vue&type=script&lang=js"
export * from "./choice-empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports